// extracted by mini-css-extract-plugin
export default {"root":"DataTypeSelect_root__dwaVy","container":"DataTypeSelect_container__KhD31"};